import type {
  ChartViewId,
  CustomTimeSegment,
  SpectralWorkspaceSession,
  TrendSignalKey,
} from '../types';
import { buildTrendExportWideDataRows } from './computeTrendExportSeries';

export type TrendExportContext = {
  readySessions: SpectralWorkspaceSession[];
  customSegments: CustomTimeSegment[];
  trendStart: string | null;
  trendEnd: string | null;
  trendNormalizationEnabled: boolean;
  trendLowPassEnabled: boolean;
  showOverlaySessions: boolean;
  selectedOverlaySessionIds: string[];
};

export const buildTrendExport = (
  context: TrendExportContext,
  feature: TrendSignalKey,
  viewId: ChartViewId
) => buildTrendExportWideDataRows(context, feature, viewId);
